/**
 * @typedef {import("@prismicio/client").Content.VideoSlice} VideoSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<VideoSlice>} VideoProps
 * @type {import("react").FC<VideoProps>}
 */
const Video = ({ slice, index, slices }) => {
  const isLast = Array.isArray(slices) && index === slices.length - 1;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`aspect-video mt-2 ${isLast ? "md:pb-10" : ""}`}
    >
      <video 
        src={slice.primary.url_video.url}
        className="w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
      />
    </section>
  );
};

export default Video;
